import { render, staticRenderFns } from "./scoreGame.vue?vue&type=template&id=2cde6995&scoped=true&"
import script from "./scoreGame.vue?vue&type=script&lang=js&"
export * from "./scoreGame.vue?vue&type=script&lang=js&"
import style0 from "./scoreGame.vue?vue&type=style&index=0&id=2cde6995&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cde6995",
  null
  
)

export default component.exports